import { RouterProvider } from 'react-router-dom';

import AppRouter from './AppRouter';

const App = () => <RouterProvider router={AppRouter} />;

export default App;
